export const RESET_FILTERS = 'reset-filters';
export const SETTINGS_CHANGE = 'settings-change';
